import React from "react";
import { useBasicDataQuery } from "../../services/basicData/basicData";
import { useGetHouseContractsQuery } from "../../services/makkahGroups";
import { useGetHouseExaminationsQuery } from "@/services/housing";

const ClientCache = ({ children }) => {
  useBasicDataQuery({ enabled: true });
  useGetHouseContractsQuery({ enabled: true });
  useGetHouseExaminationsQuery({ enabled: true });
  return <>{children}</>;
};

export default ClientCache;
